import useSWRMutation from 'swr/mutation';
import capsFetcher from '../../shared/capsFetcher';

const useGeoSearchMerchants = () => useSWRMutation('/dealerships/geo_search', (url, { arg: params }) => capsFetcher({ url, params }));

export default useGeoSearchMerchants;
